import React from "react";
import { Layout, Typography, Card, Row, Col } from "antd";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const overviewSections = [
    {
        title: "Introduction",
        content: "JectHub is an innovative online platform designed to bridge the gap between theoretical knowledge and practical experience in Artificial Intelligence (AI), Cybersecurity, and Data Science. By offering an interactive, collaborative environment, JectHub empowers students and professionals to develop their technical skills through hands-on projects, challenges, mentorship, and industry-aligned learning experiences."
    },
    {
        title: "Key Features",
        content: "\n- Challenges & Projects: Engage in AI, Cybersecurity, and Data Science challenges that enhance problem-solving skills and foster innovation.\n- Mentorship Programs: Connect with industry experts who provide guidance, career advice, and project reviews.\n- Learning Hub: Access high-quality learning resources, tutorials, and structured courses tailored to industry demands.\n- Assessments & Certifications: Validate skills through real-world assessments and earn industry-recognized certifications.\n- Networking & Collaboration: Join a community of like-minded individuals, participate in discussions, and collaborate on projects.\n- Internship & Job Listings: Gain access to exclusive internship and job opportunities within the tech ecosystem."
    },
    {
        title: "Target Audience",
        content: "\n- University Students & Graduates: Looking to gain hands-on experience and build a strong portfolio.\n- Tech Enthusiasts & Professionals: Seeking to upskill in AI, Cybersecurity, or Data Science.\n- Mentors & Industry Experts: Willing to guide and support the next generation of tech talent.\n- Organizations & Recruiters: Searching for skilled AI, Cybersecurity, and Data Science professionals."
    },
    {
        title: "Technology Stack",
        content: "\n- Frontend: React.js with Ant Design framework for a responsive and intuitive UI.\n- Backend: Java Spring Boot for robust and scalable API development.\n- Database: PostgreSQL for efficient and secure data management.\n- AI & Machine Learning: Integration of advanced AI/ML models to support personalized learning and smart assessments."
    },
    {
        title: "Business Model",
        content: "\n- Freemium Model: Basic access to challenges, mentorship, and community discussions.\n- Premium Services: Paid access to advanced certifications, in-depth courses, exclusive job listings, and personalized mentorship.\n- Corporate Partnerships: Collaboration with companies for sponsored projects, hackathons, and recruitment services."
    },
    {
        title: "Vision & Mission",
        content: "\n- Vision: To become the leading AI, Cybersecurity, and Data Science learning platform in Africa and beyond.\n- Mission: To equip students and professionals with industry-relevant skills, bridging the education-to-employment gap through real-world projects, mentorship, and career opportunities."
    },
    {
        title: "Future Roadmap",
        content: "\n- Expansion of learning modules with industry-specific AI, Cybersecurity, and Data Science case studies.\n- AI-driven personalized learning recommendations.\n- Strategic partnerships with universities and tech companies for enhanced learning experiences.\n- Launch of mobile application for seamless accessibility."
    },
    {
        title: "Conclusion",
        content: "JectHub is revolutionizing the way students and professionals acquire and apply AI, Cybersecurity, and Data Science knowledge. By fostering a dynamic, hands-on learning ecosystem, JectHub is empowering the next generation of tech talent to thrive in the digital era."
    }
];

function PlatformOverview() {
    return (
        <Layout>
            <Content style={{ padding: "50px" }}>
                <Title level={2}>Platform Overview</Title>
                <Row gutter={[16, 16]}>
                    {overviewSections.map((section, index) => (
                        <Col xs={24} sm={12} key={index}>
                            <Card>
                                <Title level={4}>{section.title}</Title>
                                <Paragraph>{section.content}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
        </Layout>
    );
}

export default PlatformOverview;
